import store from './index'
import Cookies from 'js-cookie'

const loadStateFromCookie = () => {
    const cookieData = Cookies.get('datacookies');
    return cookieData ? JSON.parse(cookieData) : undefined;
  };
  
  const initialState = loadStateFromCookie();
  
  if (initialState) {
    store.replaceState(initialState);
  }
  
  store.subscribe((mutation, state) => {
    Cookies.set('datacookies', JSON.stringify(state), { expires: 1 });
  });
  
  const remCookie = () => {
    Cookies.remove('datacookies');
  };

  export { remCookie };